module.exports = __webpack_public_path__ + "media/images/site/infantil_bambole-82dbf5f1390cc9e50c46510f3a50f0f8.jpg";